import withURLSearchParamsHandler from "../../components/hoc/withURLSearchParamsHandler";
import OrganizationDataHistory from "./OrganizationDataHistory";

const OrganizationDataHistoryWithURLSearchParamsHandler = withURLSearchParamsHandler(OrganizationDataHistory);
export default OrganizationDataHistoryWithURLSearchParamsHandler;